// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3q23r","detailsBorder":"styles_detailsBorder__2sCq3"};